// extracted by mini-css-extract-plugin
export default {"svg":"G6423da"};